import { PRIMARY } from 'constants/colors';

import { Box, SxProps } from '@mui/material';

type Props = {
  children?: React.ReactNode;
  disabled?: boolean;
  sx?: SxProps;
};

export default function BottomHeader({ children, sx = {} }: Props) {
  return (
    <Box
      display="flex"
      px={2}
      sx={{
        bgcolor: '#f7f7f7',
        borderBottom: `1px solid ${PRIMARY}`,
        ...sx
      }}
    >
      {children}
    </Box>
  );
}
